/**
 * « Chaman des pics », the snowy peaks' shop pack (ADR 0031): furs, hides and
 * bone, runes painted in ochre, a totem club, a hide shield and a snowy owl.
 * Earthy on purpose: nothing of the frost loot set's ice-blue plate, of the
 * Ice Wings or of the Company's aurora pack. Worn pieces drawn on the body
 * (ADR 0006, 0014), the mantle animated like the fire set; held pieces
 * derived from a 64 px drawing (ADR 0005).
 */
const piece = (id, name, slot) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot,
    rarity: 'epic',
    ...(slot === 'offhand' ? { classes: ['warrior'] } : {}),
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const single = (id, name, blurb, priceCents) => ({
    id,
    name,
    blurb,
    pack: 'shaman',
    items: [{ templateId: id }],
    priceCents,
});
const SLOTS = {
    'shaman-totem': 'weapon',
    'shaman-headdress': 'helmet',
    'shaman-mantle': 'chest',
    'shaman-wraps': 'gloves',
    'shaman-boots': 'boots',
    'shaman-shield': 'offhand',
};
const PIECES = [
    [
        'shaman-totem',
        'Massue-totem du chaman',
        'Un totem de bois sculpté d’un visage d’esprit, orné de plumes, porté par-dessus ton arme.',
        399,
    ],
    [
        'shaman-headdress',
        'Coiffe du chaman',
        'La tête d’un loup gris portée en capuche, plumes et perle rouge nouées au côté.',
        299,
    ],
    [
        'shaman-mantle',
        'Manteau du chaman',
        'Fourrures et peaux peintes de runes d’ocre qui s’éveillent et s’éteignent. Animé.',
        399,
    ],
    [
        'shaman-wraps',
        'Brassards d’os du chaman',
        'Des plaques d’os liées de fourrure grise, peintes d’une rune rouge.',
        199,
    ],
    [
        'shaman-boots',
        'Bottes du chaman',
        'De lourdes bottes de loup gris aux attaches d’os, rayées d’ocre rouge.',
        199,
    ],
    [
        'shaman-shield',
        'Bouclier de peau du chaman',
        'Une rondache de peau tendue frappée d’une patte rouge, plumes et perles d’os pendues à son bord.',
        299,
    ],
];
const OWL_PRICE = 299;
export const SHAMAN = {
    templates: [
        ...PIECES.map(([id, name]) => piece(id, name, SLOTS[id])),
        {
            id: 'snowy-owl',
            lootable: false,
            name: 'Harfang des neiges',
            kind: 'equipment',
            slot: 'pet',
            rarity: 'legendary',
            companion: 'snowy-owl',
            icon: 'icon.snowy-owl',
        },
    ],
    offers: [
        ...PIECES.map(([id, name, blurb, price]) => single(id, name, blurb, price)),
        single('snowy-owl', 'Harfang des neiges', 'Une chouette blanche aux yeux d’or, messagère des esprits, qui vole à ta droite. Animée.', OWL_PRICE),
        {
            id: 'shaman-pack',
            name: 'Pack du Chaman des pics',
            blurb: 'Les six pièces du chaman (massue-totem, coiffe, manteau, brassards, bottes et bouclier) et le harfang des neiges, par-dessus ton équipement.',
            pack: 'shaman',
            items: [...PIECES.map(([id]) => ({ templateId: id })), { templateId: 'snowy-owl' }],
            priceCents: 999,
            worthCents: PIECES.reduce((sum, [, , , price]) => sum + price, OWL_PRICE),
        },
    ],
};
//# sourceMappingURL=shaman.js.map